import { Card, CardContent, Typography } from '@optimus-web/core';

export const Accounts = () => (
    <Card padding="0" overflowHidden variant="highlighted" outline>
        <CardContent padding="200">
            <Typography textStyle="bodyMediumStrong" variant="secondary" align="center" as="div">
                Accounts
            </Typography>
        </CardContent>
    </Card>
);
